export interface ICreateEmail {
  name: string;
  mailLabel: string;
  email: string;
  host: string;
  port: number;
  enableSSL: boolean;
  username: string;
  password: string;
  isActive: boolean;
}

export interface IUpdateEmail extends ICreateEmail {
  id: string;
}

export interface IEmail extends IUpdateEmail {
  isPredefined: boolean;
}

export interface ISendEmail {
  documentId: string;
  documentType: DOCUMENT_TYPE;
}

export enum DOCUMENT_TYPE {
  labelReport = 1,
  settlement = 2,
  contract = 3,
}
